import React from 'react';
import './PaymentMethod.scss';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';

export const PaymentMethod = (props) => {

    return (
        <div>
            <div className='font-14 bold-text pb-2'>Payment Method</div>
            <div>
                {
                    props.paymentOptions.length > 0 && props.paymentOptions.map((item, i) => (
                        <div className="d-flex align-items-center pl-3 font-14" key={i}>
                            <FormControlLabel
                                name={item.name}
                                value={item.value}
                                control={<Radio color="primary" size="small" />}
                                label={item.text}
                                checked={item.checked}
                                onChange={() => props.onPaymentModeChange(item)}
                            />                
                        </div>
                    ))
                }
            </div>
        </div>
    );
};